import { useAuth0 } from "@auth0/auth0-react";
import { useCallback } from "react";
import wretch from "wretch";
import { Wretch } from "wretch/types";
import settings from "../config";
import { maintenanceRoute } from "../routes/pages/maintenance/route";
import { isBackendOfflineState } from "../routes/Router";
import { useState as useStatePool } from "state-pool";


type UseApiReturnValue = {
    getApi: () => Promise<Wretch>,
    getApiWithoutAPIGateway: () => Promise<Wretch>,
}

export default function useApi(): UseApiReturnValue {
    const [isBackendOffline ,setIsBackendOffline] = useStatePool(isBackendOfflineState);
    const { getAccessTokenSilently } = useAuth0();

    const getApi = useCallback(async () => {
        const token: string = await getAccessTokenSilently()
        setIsBackendOffline(false);
        return wretch()
            .url(settings.API_URL)
            .auth(`Bearer ${token}`)
            .catcher(502, err => {
                setIsBackendOffline(true);
            })
            .catcher(503, err => {
                setIsBackendOffline(true);
            })
            .catcher(504, err => {
                setIsBackendOffline(true);
            })
            .catcher(404, err => {
                const containerMessage = "Error 404 - This Container App is stopped or does not exist.";
                var containerIsStopped = err.text?.includes(containerMessage) 
                    || err.message.includes(containerMessage)
                    || err.text.includes(containerMessage);                    
                    if (containerIsStopped) {
                        setIsBackendOffline(true);
                    } else {
                        throw err;
                    }
            });
        }, [getAccessTokenSilently])

    const getApiWithoutAPIGateway = useCallback(async () => {
        return wretch()
    }, [])

    return {
        getApi,
        getApiWithoutAPIGateway,
    }
}
